var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78594 4.54991C8.27402 4.33362 10.7762 4.33362 13.2643 4.54991L14.463 4.65411C15.261 4.72348 15.9445 5.19946 16.2986 5.88031C16.3439 5.96742 16.3099 6.07287 16.2265 6.12455L11.2529 9.20341C10.1862 9.86373 8.84124 9.87759 7.76118 9.23937L2.75441 6.28083C2.67352 6.23303 2.63639 6.13464 2.67285 6.04804C2.99682 5.27845 3.72518 4.72905 4.5872 4.65411L5.78594 4.54991Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66877 7.61316C2.54498 7.54001 2.38702 7.61873 2.37259 7.7618C2.17119 9.75855 2.21994 11.7742 2.51883 13.7618C2.67639 14.8097 3.53157 15.613 4.5872 15.7047L5.78594 15.8089C8.27402 16.0252 10.7762 16.0252 13.2643 15.8089L14.463 15.7047C15.5186 15.613 16.3738 14.8097 16.5314 13.7618C16.839 11.7163 16.8816 9.64105 16.6594 7.58728C16.6438 7.4432 16.4831 7.36594 16.3599 7.44221L11.8796 10.2157C10.4365 11.1091 8.61674 11.1279 7.15549 10.2644L2.66877 7.61316Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.7d561ef1cd92c841d0107a3e5015e68e.svg";
export { ForwardRef as ReactComponent };